function calculateOptimalColumns(productCount, minColumns = 3, maxColumns = 5) {
	// Special case: if only 2 products and minColumns allows it, use 2 columns
	if (productCount === 2 && minColumns <= 2) {
		return 2;
	}

	// Start from max columns and check for perfect division first
	if (productCount % maxColumns === 0) {
		return maxColumns;
	}

	// Work down from max columns to find perfect division
	for (let columns = maxColumns - 1; columns >= minColumns; columns--) {
		if (productCount % columns === 0) {
			return columns;
		}
	}

	// If no perfect division found, return the column count that maximizes remainder
	let bestColumns = maxColumns;
	let largestRemainder = productCount % maxColumns;

	for (let columns = minColumns; columns <= maxColumns; columns++) {
		const remainder = productCount % columns;
		if (remainder > largestRemainder) {
			largestRemainder = remainder;
			bestColumns = columns;
		}
	}

	return bestColumns;
}
